import { getBaseApi } from "../api";
import type { User } from "../types";

const api = getBaseApi();

export const getUser = async (userId: string) => {
  const response = await api.get(`/users/${userId}`);
  return response.data?.data;
};

export const updatePassword = async (userId: string, data: any) => {
  const response = await api.put(`/users/${userId}/password`, data);
  return response.data?.data;
};

export const updateUser = async (userId: string, data: Partial<User>) => {
  const response = await api.put(`/users/${userId}`, data);
  return response.data?.data;
};

export const updateUserEmail = async (userId: string, data: { newEmail: string }) => {
  const response = await api.put(`/users/${userId}/email`, data);
  return response.data?.data;
};

export const deleteAccount = async (userId: string, password: string) => {
  const response = await api.post(`/users/${userId}/delete`, { password });
  return response.data?.data;
};

export const disableAccount = async (userId: string, password: string) => {
  const response = await api.post(`/users/${userId}/disable`, { password });
  return response.data?.data;
};